module.exports = ['events.list.pasts.partners.count', 'events.list.pasts.notpartners.count', 'events.list.pasts.partners.title.past', 'events.list.pasts.noneFound', 'events.link.pasts.to.futures'];
